import type { CommitteeInfo, SuiSystemStateSummary } from "@mysten/sui/jsonRpc";
import { AftermathApi } from "../../../general/providers/aftermathApi";
import { Helpers } from "../../../general/utils";

export class SuiApi {
	// =========================================================================
	//  Class Members
	// =========================================================================

	// =========================================================================
	//  Constructor
	// =========================================================================

	constructor(private readonly api: AftermathApi) {}

	// =========================================================================
	//  Inspections
	// =========================================================================

	/**
	 * @deprecated Use `getSystemState()` method instead.
	 * This method will be removed in a future release.
	 * @example
	 * ```typescript
	 * const afSdk = await Aftermath.create({ network: "MAINNET" });
	 *
	 * const sui = afSdk.Sui();
	 *
	 * const systemState = await sui.getSystemState();
	 * console.log(systemState.epoch, systemState.validators);
	 */
	public fetchSystemState = async (): Promise<SuiSystemStateSummary> => {
		const systemState = await this.api.client.getLatestSuiSystemState();

		const activeValidators = systemState.activeValidators.map((validator) => ({
			...validator,
			suiAddress: Helpers.addLeadingZeroesToType(validator.suiAddress),
		}));

		return {
			...systemState,
			activeValidators,
		} as SuiSystemStateSummary;
	};
}
